export const LOGOMAKER_GRAY_FOR_WHITE_LOGOS = '#99989a'
export const TRANSPARENT_BACKGROUND_PATTERN_GRAY = '#e0e0e0'
export const COLOR_BLACK = '#000000'
export const COLOR_WHITE = '#FFFFFF'
